import { Stack, Divider } from "@mui/material";
import { DateRangeFilterModel } from "./DateRangeFilter";
import { DatePicker } from "../../atoms";

export type LocalDateRangePickerProps = {
  onChange?: (filter: DateRangeFilterModel) => void;
  filter?: DateRangeFilterModel;
};
export function LocalDateRangePicker({ filter, onChange = () => {} }: LocalDateRangePickerProps) {
  return (
    <div>
      <Stack
        direction={"row"}
        sx={{
          borderRadius: "0.75rem",
          border: "0.0625rem solid rgba(255, 255, 255, 0.3)",
        }}
      >
        <DatePicker
          value={filter?.fromDate}
          placeholder="Start"
          noBorder
          showIcon={false}
          onChange={(date) => {
            onChange({
              fromDate: date,
              toDate: filter?.toDate,
              type: filter?.type!,
            });
          }}
        />
        <Divider orientation="vertical" flexItem variant="middle" />
        <DatePicker
          noBorder
          showIcon={false}
          value={filter?.toDate}
          placeholder="End"
          onChange={(date) => {
            onChange({
              fromDate: filter?.fromDate,
              toDate: date,
              type: filter?.type!,
            });
          }}
        />
      </Stack>
    </div>
  );
}
